import clsx from 'clsx';
interface FullPageLoaderProps {className?: string; screen?: boolean;}
export function FullPageLoader({className, screen}: FullPageLoaderProps) {
 return <div role="status" aria-label="Loading page" className={clsx('flex flex-auto items-center justify-center', screen ? 'h-screen w-screen' : 'h-full w-full',className)}><img src="/imported-assets/musicspot-loading.svg" alt="" width={72} height={72} /></div>;
}
